import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const existsProductionRoadmapProducts = async () => {
	const response = await api.get('/roteiroProducao/existeRoteiroProducao');
	return response.data;
};

export const useExistsRoadmapProduction = () => {
	return useQuery(
		['roadmap-production-products-exists'],
		existsProductionRoadmapProducts,
		{
			refetchOnWindowFocus: false,
		}
	);
};
